// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnergySavingPatternDescription_container__uGjHf {
  display: grid;
  grid-template-columns: 3fr 5fr;
  gap: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/EnergySaving/EnergySavingPatternDescription.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AACF","sourcesContent":[".container {\n  display: grid;\n  grid-template-columns: 3fr 5fr;\n  gap: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EnergySavingPatternDescription_container__uGjHf`
};
export default ___CSS_LOADER_EXPORT___;
